/**
 * ACQUISITION PHASE CONFIGURATION
 * 
 * Single source of truth for all acquisition phase-related configurations.
 * This file defines:
 * - Phase columns with display properties (colors, labels)
 * - Phase display names and colors
 * 
 * To modify the kanban board structure:
 * 1. Update the acquisitionPhaseColumns array for visual changes
 * 2. All dependent components will automatically reflect changes
 */

import { AcquisitionPhase } from 'shared/types/acquisition';

// Column configuration for the kanban board
export interface AcquisitionPhaseColumn {
  id: AcquisitionPhase;
  label: string;
  color: string;
  bgColor: string;
  headerBgColor: string;
  borderColor: string;
}

/**
 * Phase column configurations for the kanban board
 * Defines the visual appearance and order of columns
 */
export const acquisitionPhaseColumns: AcquisitionPhaseColumn[] = [
  {
    id: AcquisitionPhase.INBOX,
    label: 'Inbox',
    color: 'text-neutral-600',
    bgColor: 'bg-neutral-50/50',
    headerBgColor: 'bg-neutral-100',
    borderColor: 'border-neutral-200',
  },
  {
    id: AcquisitionPhase.ADD_DATA,
    label: 'Opgepikt',
    color: 'text-blue-600',
    bgColor: 'bg-blue-50/50',
    headerBgColor: 'bg-blue-50',
    borderColor: 'border-blue-200',
  },
  {
    id: AcquisitionPhase.ACQUISITION_MEETING_AGENDA,
    label: 'Agenda ACQ meeting',
    color: 'text-purple-600',
    bgColor: 'bg-purple-50/50',
    headerBgColor: 'bg-purple-50',
    borderColor: 'border-purple-200',
  },
  {
    id: AcquisitionPhase.RVB_AGENDA,
    label: 'Agenda RVB',
    color: 'text-orange-600',
    bgColor: 'bg-orange-50/50',
    headerBgColor: 'bg-orange-50',
    borderColor: 'border-orange-200',
  },
  {
    id: AcquisitionPhase.DEAL,
    label: 'Deal!',
    color: 'text-green-600',
    bgColor: 'bg-green-50/50',
    headerBgColor: 'bg-green-50',
    borderColor: 'border-green-200',
  },
  {
    id: AcquisitionPhase.REJECTED,
    label: 'Afgewezen',
    color: 'text-red-600',
    bgColor: 'bg-red-50/50',
    headerBgColor: 'bg-red-50',
    borderColor: 'border-red-200',
  },
];

/**
 * Get column configuration by phase
 */
export const getColumnByPhase = (phase: AcquisitionPhase): AcquisitionPhaseColumn | undefined => {
  return acquisitionPhaseColumns.find(col => col.id === phase);
};

